<template>
  <!-- Placeholder shaped like LayoutPage (a card with the sd-page-header toolbar
       over a content body), so a pending load reads as the page about to appear
       rather than a bare block dropped into the app shell. -->
  <v-card class="layout-page-skeleton" outlined>
    <v-toolbar flat class="sd-page-header px-2">
      <v-skeleton-loader
        type="heading"
        width="240"
        class="layout-page-skeleton__title"
      />
      <v-spacer />
      <v-skeleton-loader type="chip" class="mr-2 d-none d-sm-block" />
      <v-skeleton-loader type="avatar" />
    </v-toolbar>
    <v-divider />
    <v-card-text>
      <!-- A row of tile placeholders over a table body: the shape most reports
           and dashboards settle into once loaded. -->
      <v-row>
        <v-col v-for="n in 4" :key="n" cols="12" sm="6" md="3">
          <v-skeleton-loader type="image" height="100" class="rounded" />
        </v-col>
      </v-row>
      <v-skeleton-loader
        type="table-heading, table-row-divider@6"
        class="mt-6"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LayoutPageSkeleton",
};
</script>

<style scoped>
.layout-page-skeleton {
  width: 100%;
}
/* Keep the title bar the same height as a real page header so the swap to the
   loaded page does not shift the content. */
.layout-page-skeleton__title ::v-deep .v-skeleton-loader__heading {
  margin: 0;
}
</style>
